import { createContext, useContext } from "react";

import type { FormListParentName } from "../types";

/**
 * Context to share information across a form list UI tree
 */
export const FormListContext = createContext<{ parentName: FormListParentName }>({
  parentName: [],
});

export function useFormListParentName(): Array<string | number> {
  const { parentName } = useContext(FormListContext);

  return parentName;
}
